module.exports = __webpack_public_path__ + "img/Jump Casting54.8598013b.jpg";